import type { DocLinkSlug } from "../../../../../components/react/docLink/AllDocLinkSlugs";

// TODO: Update doc slug
export const SILENCING_DOC_LINK_SLUG = "configure-smtp" satisfies DocLinkSlug;
